module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/deleted-folder-96c2fe4ade74dd1e23dc50b5b2fcddfa.svg";